module.exports = __webpack_public_path__ + "assets/images/cb9cc2645eb4b89aaf6af8798039cd20.png";